import { render, staticRenderFns } from "./package-type-switch.vue?vue&type=template&id=ba4d2c14&scoped=true&"
import script from "./package-type-switch.vue?vue&type=script&lang=js&"
export * from "./package-type-switch.vue?vue&type=script&lang=js&"
import style0 from "./package-type-switch.vue?vue&type=style&index=0&id=ba4d2c14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4d2c14",
  null
  
)

export default component.exports